import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";
import { data } from "../data";
import { Dropdown } from "./helpers/constants";

import { onChange } from "./helpers/on-change"

const DEFAULT_HORIZONTAL_OVERFLOW: string = "properties.styles.$deviceType.overflowX";
const OVERFLOW_HORIZONTAL_LABEL = "Horizontal"

const DEFAULT_VERTICAL_OVERFLOW: string = "properties.styles.$deviceType.overflowY";
const OVERFLOW_VERTICAL_LABEL = "Vertical"

type Props = {
  isCheckedIn: boolean;
  defaultValue?: string;
}

export const OverflowX = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState(defaultValue);
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = data.overflowX.find(item => item.value === getValue(component, DEFAULT_HORIZONTAL_OVERFLOW.split("."), deviceType))?.label ?? data.overflowX[2].label;
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_HORIZONTAL_OVERFLOW.split("."), deviceType)]);

  return (
    <div className="panel-div">
      <label
        htmlFor="overflowHorizontal"
        className="panel-label"
      >
        {OVERFLOW_HORIZONTAL_LABEL}
      </label>
      <Dropdown
        id="overflowHorizontal"
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={
          data.overflowX
            ? data.overflowX.map((el) => ({
              name: el.label,
            }))
            : []
        }
        selected={{ name: value as string }}
        onChange={(option) => {
          if (data.overflowX) {
            const item = data.overflowX.find(item => item.label === option.name)
            if (item) {
              const value = item.value
              setValue(value)
              onChange({
                path: DEFAULT_HORIZONTAL_OVERFLOW,
                value,
                oldValue,
                setOldValue,
                selectedElementId
              })
            }
          }
        }}
      />
    </div>
  )
};

export const OverflowY = (props: Props) => {
    const { components } = getComponents()
    const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
    const { isCheckedIn, defaultValue } = props;
    const [oldValue, setOldValue] = useState<string>("");
    const [value, setValue] = useState(defaultValue);
    const component = components[selectedElementId];
  
    useEffect(() => {
      if (component) {
        const previousValue = data.overflowY.find(item => item.value === getValue(component, DEFAULT_VERTICAL_OVERFLOW.split("."), deviceType))?.label ?? data.overflowY[2].label;
        setValue(previousValue)
        setOldValue(previousValue)
      }
      // eslint-disable-next-line
    }, [getValue(component, DEFAULT_VERTICAL_OVERFLOW.split("."), deviceType)]);
  
    return (
      <div className="panel-div">
        <label
          htmlFor="overflowHorizontal"
          className="panel-label"
        >
          {OVERFLOW_VERTICAL_LABEL}
        </label>
        <Dropdown
          id="overflowHorizontal"
          cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
          disabled={!isCheckedIn}
          options={
            data.overflowY
              ? data.overflowY.map((el) => ({
                name: el.label,
              }))
              : []
          }
          selected={{ name: value as string }}
          onChange={(option) => {
            if (data.overflowY) {
              const item = data.overflowY.find(item => item.label === option.name)
              if (item) {
                const value = item.value
                setValue(value)
                onChange({
                  path: DEFAULT_VERTICAL_OVERFLOW,
                  value,
                  oldValue,
                  setOldValue,
                  selectedElementId
                })
              }
            }
          }}
        />
      </div>
    )
  };